__turbopack_context__.v({
  "--checkbox": "entry-images-desktop-sidebar-module-scss-module__ZX0XoG__--checkbox",
  "--imageupload": "entry-images-desktop-sidebar-module-scss-module__ZX0XoG__--imageupload",
  "--select": "entry-images-desktop-sidebar-module-scss-module__ZX0XoG__--select",
  "--textarea": "entry-images-desktop-sidebar-module-scss-module__ZX0XoG__--textarea",
  "--textfield": "entry-images-desktop-sidebar-module-scss-module__ZX0XoG__--textfield",
  "__additional-field": "entry-images-desktop-sidebar-module-scss-module__ZX0XoG____additional-field",
  "__additional-field-container": "entry-images-desktop-sidebar-module-scss-module__ZX0XoG____additional-field-container",
  "__additional-field-label": "entry-images-desktop-sidebar-module-scss-module__ZX0XoG____additional-field-label",
  "__button-text": "entry-images-desktop-sidebar-module-scss-module__ZX0XoG____button-text",
  "__close-button": "entry-images-desktop-sidebar-module-scss-module__ZX0XoG____close-button",
  "__content": "entry-images-desktop-sidebar-module-scss-module__ZX0XoG____content",
  "__description-text": "entry-images-desktop-sidebar-module-scss-module__ZX0XoG____description-text",
  "__pagination-text": "entry-images-desktop-sidebar-module-scss-module__ZX0XoG____pagination-text",
  "__title-text": "entry-images-desktop-sidebar-module-scss-module__ZX0XoG____title-text",
  "__vote-button": "entry-images-desktop-sidebar-module-scss-module__ZX0XoG____vote-button",
  "desktop-sidebar": "entry-images-desktop-sidebar-module-scss-module__ZX0XoG__desktop-sidebar",
});
